export const menuTitle = { title: "TYPE INDUSTRY", label: "Type Industry" }
  